/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Boris Kudlač (kudlac@cadwork.cz)
 *
 */

import ViewMode from "App/view/modes/view_mode";
import {vec2} from "gl-matrix";
import View from "App/view/view";
// @ts-ignore
import {ViewModeEnum} from "js_interface/src/modules/view_mode/scene_view_mode_enums.ts";
import RenderDocument from "App/render_document";

export default
class ViewModeSingle extends ViewMode {
    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);

        let view = new View(this, this.rdocument, vec2.fromValues(0, 0), vec2.fromValues(100, 100));
        this.addView(view);
        this.activeView = view;

        this.createLights();
    }

    public getModeType(): ViewModeEnum {
        return ViewModeEnum.SINGLE;
    }
}
